import { Chip, Tooltip } from '@mui/material';
import dayjs from 'dayjs';

/**
 * The honest staleness display (TRD §9.4 / decision #23): every analytics surface shows
 * WHEN its data was ingested, plainly — this chip IS the platform's freshness alerting.
 * Amber once the data is older than a missed nightly sync would make it.
 */
export const AsOfChip = ({ asOf }: { asOf: string | null }) => {
  if (!asOf) {
    return <Chip size="small" color="warning" label="No data yet" />;
  }
  const ingested = dayjs(asOf);
  const hoursOld = dayjs().diff(ingested, 'hour');
  const stale = hoursOld > 26; // nightly cadence + margin: older means a sync was missed
  return (
    <Tooltip title={ingested.format('DD MMM YYYY, HH:mm')}>
      <Chip
        size="small"
        color={stale ? 'warning' : 'default'}
        variant={stale ? 'filled' : 'outlined'}
        label={`Data as of ${ingested.format('DD MMM, HH:mm')}${stale ? ' — sync overdue' : ''}`}
      />
    </Tooltip>
  );
};
